const unitScale = {
    100: 4,
    50: 2,
    150: 6,
    200: 8,
    250: 10,
    300: 12,
    400: 16,
    500: 20,
    600: 24,
    700: 28,
    800: 32,
    1000: 40,
    1200: 48,
    1400: 56,
    1600: 64,
    2000: 80,
    2500: 100,
    3000: 120,
    3100: 124,
    3200: 128,
    3300: 132,
    3400: 136,
    3500: 140,
    3600: 144,
    3700: 148,
    3800: 152,
    3900: 156,
    4000: 160,
};
export const spacing = unitScale;
export const rounded = unitScale;
//# sourceMappingURL=spacing.js.map